// extracted by mini-css-extract-plugin
export var orderDetails = "_s6-2";
export var orderImage = "_s6-1";
export var orderMeta = "_s6-3";
export var orderSummary = "_s6-0";
export var rightArrow = "_s6-4";